<template>
  <div class="app-container">
    <!-- 搜索区域 -->
    <el-form :model="queryParams" ref="queryForm" size="small" label-width="100px">
      <el-row :gutter="24" type="flex">
        <el-col :span="6">
          <el-form-item label="记录号" prop="recordNum">
            <el-input v-model="queryParams.recordNum" placeholder="请输入记录号" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="识别码" prop="OIDNO">
            <el-input v-model="queryParams.OIDNO" placeholder="请输入识别码" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="使用单位" prop="USE_UNT_NAME">
            <el-input v-model="queryParams.USE_UNT_NAME" placeholder="请输入使用单位" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="产品编号" prop="FACTORY_COD">
            <el-input v-model="queryParams.FACTORY_COD" placeholder="请输入产品编号" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24" type="flex">
        <el-col :span="6">
          <el-form-item label="登记证号" prop="EQP_USECERT_COD">
            <el-input v-model="queryParams.EQP_USECERT_COD" placeholder="请输入登记证号" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="内部编号" prop="EQP_INNER_COD">
            <el-input v-model="queryParams.EQP_INNER_COD" placeholder="请输入内部编号" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="检测日期" prop="testDate">
            <el-date-picker v-model="queryParams.testDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 100%"
                            @change="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="文件状态" prop="fileUpdState">
            <el-select v-model="queryParams.fileUpdState" placeholder="请选择文件状态" clearable style="width: 100%" @change="handleQuery">
              <el-option label="全部" value=""></el-option>
              <el-option label="已上传" value="1"></el-option>
              <el-option label="未上传" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div style="text-align: center; margin-bottom: 10px;">
        <!-- <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">查询</el-button> -->
        <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleQuery="handleQuery" />
        <!-- <el-button icon="el-icon-refresh" size="small" @click="handleReset">重置</el-button> -->
      </div>

      <!-- 数据表格 -->
      <el-table v-loading="loading" :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' } " height="500"
                element-loading-text="正在查询数据..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-table-column type="index" label="序号" width="60" align="left" :index="indexMethod"></el-table-column>
        <el-table-column label="检测日期" align="left" prop="testDate" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="文件状态" align="left" min-width="100">
          <template slot-scope="scope">
            <!-- <el-tag type="success" v-if="scope.row.videoSize">已上传</el-tag>
            <el-tag type="warning" v-else>未上传</el-tag> -->
            <el-tag type="success" v-if="scope.row.status == '已上传' || (scope.row.status == '1' && scope.row.videoSize)">已上传</el-tag>
            <el-tag type="info" v-else-if="scope.row.status == '4'">视频处理中</el-tag>
            <el-tag type="danger" v-else-if="scope.row.status == '3'">视频合并中</el-tag>
            <el-tag type="warning" v-else>未上传</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="视频大小" align="left" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.videoSize">{{ (scope.row.videoSize / 1024 / 1024 ).toFixed(2) }} MB</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="使用单位" align="left" prop="USE_UNT_NAME" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column label="小区名称" align="left" prop="houseName" min-width="130" show-overflow-tooltip></el-table-column>
        <el-table-column label="识别码" align="left" prop="OIDNO" min-width="130" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column label="记录号" align="left" prop="recordNum" min-width="220" show-overflow-tooltip></el-table-column> -->
        <!-- <el-table-column label="检测人" align="left" prop="employeeName" min-width="100" show-overflow-tooltip></el-table-column> -->
        <!-- <el-table-column label="设备代码" align="left" prop="EQP_STATION_COD" min-width="120" show-overflow-tooltip></el-table-column> -->
        <!-- <el-table-column label="登记证号" align="left" prop="EQP_USECERT_COD" min-width="140" show-overflow-tooltip></el-table-column> -->
        <el-table-column label="产品编号" align="left" prop="FACTORY_COD" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="内部编号" align="left" prop="EQP_INNER_COD" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="使用地址" align="left" prop="EQP_USE_ADDR" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="客户名称" align="left" prop="compName" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column label="委托编码" align="left" prop="entrustNum" min-width="210" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" align="left" width="200" fixed="right">
          <template slot-scope="scope">
            <!-- 上传进度条 -->
            <div v-if="uploadingRows[scope.row.entrustNum]" class="upload-progress-cell">
              <div class="progress-wrapper">
                <el-progress :percentage="Math.round(uploadingRows[scope.row.entrustNum].progress * 100)" :status="uploadingRows[scope.row.entrustNum].status === 'success' ? 'success' : undefined"
                             :stroke-width="18" :color="uploadingRows[scope.row.entrustNum].status === 'calculating' ? '#E6A23C' : 
                          uploadingRows[scope.row.entrustNum].status === 'uploading' ? '#67C23A' : undefined" :show-text="false" />
                <div class="progress-text" :class="'text-' + uploadingRows[scope.row.entrustNum].status">
                  {{ uploadingRows[scope.row.entrustNum].status === 'calculating' ? '视频加密中...' :
                     uploadingRows[scope.row.entrustNum].status === 'uploading' ? 
                       (uploadingRows[scope.row.entrustNum].speedText ? '上传中: ' + uploadingRows[scope.row.entrustNum].speedText : '文件上传中...') :
                     uploadingRows[scope.row.entrustNum].status === 'success' ? '上传完成' :
                     uploadingRows[scope.row.entrustNum].status === 'error' ? '上传失败' : '准备上传' }}
                </div>
                <div class="progress-percentage" :class="'text-' + uploadingRows[scope.row.entrustNum].status">
                  {{ Math.round(uploadingRows[scope.row.entrustNum].progress * 100) }}%
                </div>
              </div>
            </div>
            <!-- 操作按钮 -->
            <div v-else-if="scope.row.status == '3' || scope.row.status == '4'" class="upload-progress-cell">
              <div class="processing-text" style="color: #909399;">
                <i class="el-icon-loading"></i> 视频处理中，请稍后刷新
              </div>
            </div>
            <PermissionMethodRow v-else :url="url" :id="'rowtoolbar'" :disabled-buttons="getDisabledButtons(scope.row)" @handleUploadSingle="handleUploadSingle(scope.row)"
                                 @handleReUploadSingle="handleReUploadSingle(scope.row)" @handleViewSingle="handleViewSingle(scope.row)" />
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currPage" :page-sizes="[10, 20, 50, 100]" :page-size="queryParams.pageSize"
                     layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px; text-align: right;" />
    </el-form>

    <!-- 上传对话框 -->
    <el-dialog title="上传视频文件" :visible.sync="uploadDialogVisible" width="700px" :before-close="closeUploadDialog" :close-on-click-modal="false">
      <el-form :model="uploadForm" label-width="100px">
        <el-form-item label="委托编码">
          <el-input v-model="uploadForm.entrustNum" disabled />
        </el-form-item>
        <el-form-item label="记录号">
          <el-input v-model="uploadForm.recordNum" disabled />
        </el-form-item>
        <el-form-item label="识别码">
          <el-input v-model="uploadForm.OIDNO" disabled />
        </el-form-item>
        <el-form-item label="上传文件">
          <file-upload ref="fileUpload" accept=".mp4,.avi" tip-text="请上传使用客户端合并后的单个.mp4 或单个.avi文件" :limit="1" :chunk-size="100 * 1024 * 1024" :concurrent="4" :base-url="uploadBaseUrl"
                       :extra-params="uploadExtraParams" :show-progress="false" :show-action-buttons="false" :auto-calculate-md5="false" @file-selected="handleFileSelected"
                       @md5-progress="handleMd5Progress" @md5-calculated="handleMd5Calculated" @upload-start="handleUploadStart" @chunk-uploaded="handleChunkUploaded"
                       @upload-success="handleUploadSuccess" @upload-error="handleUploadError" @upload-cancel="handleUploadCancel" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleStartUpload">开始上传</el-button>
        <el-button @click="closeUploadDialog">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 隐藏的上传实例容器 - 用于并行上传 -->
    <div style="display: none;">
      <file-upload v-for="(instance, entrustNum) in uploadInstances" :key="entrustNum" :ref="'fileUpload_' + entrustNum" accept=".mp4" tip-text="" :limit="1" :chunk-size="100 * 1024 * 1024"
                   :concurrent="3" :base-url="uploadBaseUrl" :extra-params="instance.extraParams" :show-progress="false" :show-action-buttons="false" :auto-calculate-md5="false"
                   @md5-progress="(data) => handleInstanceMd5Progress(entrustNum, data)" @md5-calculated="(data) => handleInstanceMd5Calculated(entrustNum, data)"
                   @all-md5-calculated="(data) => handleInstanceAllMd5Calculated(entrustNum, data)" @upload-start="(data) => handleInstanceUploadStart(entrustNum, data)"
                   @upload-progress="(data) => handleInstanceUploadProgress(entrustNum, data)" @chunk-uploaded="(data) => handleInstanceChunkUploaded(entrustNum, data)"
                   @upload-success="(data) => handleInstanceUploadSuccess(entrustNum, data)" @upload-error="(data) => handleInstanceUploadError(entrustNum, data)"
                   @upload-cancel="(data) => handleInstanceUploadCancel(entrustNum, data)" />
    </div>

    <!-- 视频播放对话框 -->
    <el-dialog title="视频播放" :visible.sync="videoDialogVisible" width="800px" :before-close="closeVideoDialog" :close-on-click-modal="false">
      <div class="video-container">
        <video v-if="currentVideoUrl" ref="videoPlayer" :src="currentVideoUrl" controls width="100%" style="max-height: 500px;">
          您的浏览器不支持视频播放
        </video>
        <div v-else class="no-video">
          <i class="el-icon-video-camera" style="font-size: 48px; color: #ccc;"></i>
          <p style="color: #999; margin-top: 10px;">暂无视频</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeVideoDialog">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryUploadFileList } from '@/api/contract/contract';
import FileUpload from '@/components/FileUpload';

export default {
  name: 'Upload',
  components: {
    FileUpload
  },
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 表格数据
      tableData: [],
      // 查询参数
      queryParams: {
        currPage: 1,
        pageSize: 10,
        recordNum: undefined,
        OIDNO: undefined,
        videoSize: undefined,
        USE_UNT_NAME: undefined,
        EQP_STATION_COD: undefined,
        FACTORY_COD: undefined,
        EQP_USECERT_COD: undefined,
        EQP_INNER_COD: undefined,
        EQP_USE_ADDR: undefined,
        testDate: null,
        fileUpdState: undefined
      },
      // 上传对话框
      uploadDialogVisible: false,
      uploadForm: {
        id: undefined,
        entrustNum: '',
        recordNum: '',
        OIDNO: ''
      },
      // 上传配置
      uploadBaseUrl: '/api/file/upload',
      uploadExtraParams: {},
      // 视频播放对话框
      videoDialogVisible: false,
      currentVideoUrl: '',
      // 上传进度管理
      uploadingRows: {}, // 存储正在上传的行数据 { entrustNum: { progress: 0.5, status: 'uploading' | 'success' | 'error', fileName: 'xxx' }
      currentUploadRowId: null, // 当前正在上传的行 entrustNum
      // 上传实例管理 - 用于并行上传
      uploadInstances: {} // 存储每个行的独立上传实例 { entrustNum: { extraParams: {}, fileObj: null } }
    }
  },
  created () {
    this.getList();
  },
  methods: {
    // 计算序号（考虑分页）
    indexMethod (index) {
      return (this.queryParams.currPage - 1) * this.queryParams.pageSize + index + 1;
    },
    // 查询列表
    getList () {
      this.loading = true;

      // 构建查询参数
      const params = { ...this.queryParams };

      // 处理日期范围
      //if (params.testDate && params.testDate.length === 2) {
      //  params.testDateStart = params.testDate[0];
      //  params.testDateEnd = params.testDate[1];
      //  delete params.testDate;
      //} else {
      //  delete params.testDate;
      //}

      // 调用API
      queryUploadFileList(params).then(res => {
        if (res && res.additionalData) {
          const { records = [], current = this.queryParams.currPage, size = this.queryParams.pageSize, total = 0 } = res.additionalData || {};
          console.log('表格数据:', records);
          if (records.length > 0) {
            console.log('第一条数据结构:', records[0]);
          }
          this.tableData = records;
          this.queryParams.currPage = current;
          this.queryParams.pageSize = size;
          this.total = total;
        } else {
          this.$message.error((res && res.message) || '获取数据列表失败');
        }
        this.loading = false;
      }).catch(error => {
        console.error('获取数据列表失败:', error);
        this.loading = false;
        this.$message.error('获取数据列表失败');
      });
    },
    // 查询按钮
    handleQuery () {
      this.queryParams.currPage = 1;
      this.getList();
    },
    // 重置按钮
    handleReset () {
      this.queryParams = {
        currPage: 1,
        pageSize: 10,
        recordNum: undefined,
        OIDNO: undefined,
        videoSize: undefined,
        USE_UNT_NAME: undefined,
        EQP_STATION_COD: undefined,
        FACTORY_COD: undefined,
        EQP_USECERT_COD: undefined,
        EQP_INNER_COD: undefined,
        EQP_USE_ADDR: undefined,
        testDate: null,
        fileUpdState: undefined
      };
      this.getList();
    },
    // 上传按钮
    handleUploadSingle (row) {
      console.log('点击上传的行数据:', row);

      this.uploadForm = {
        id: row.entrustNum,
        entrustNum: row.entrustNum,
        recordNum: row.recordNum,
        OIDNO: row.OIDNO
      };

      // 设置额外的上传参数
      this.uploadExtraParams = {
        id: row.entrustNum,
        entrustNum: row.entrustNum,
        recordNum: row.recordNum,
        OIDNO: row.OIDNO
      };

      this.currentUploadRowId = row.entrustNum;

      // 清除文件选择，但不取消正在进行的上传
      this.$nextTick(() => {
        if (this.$refs.fileUpload) {
          this.$refs.fileUpload.clearFileSelection();
        }
        this.uploadDialogVisible = true;
      });
    },
    // 重新上传按钮
    handleReUploadSingle (row) {
      if (row.ispinfoSubmitState == 0) {
        this.$message.warning('该数据已上传到监管，无法重新上传');
        return;
      }
      this.$confirm('确认要重新上传该记录的视频文件吗？重新上传将覆盖原有文件。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleUploadSingle(row);
      }).catch(() => {
        this.$message.info('已取消重新上传');
      });
    },
    // 关闭上传对话框
    closeUploadDialog () {
      this.uploadDialogVisible = false;
    },
    // 开始上传流程
    handleStartUpload () {
      console.log('handleStartUpload 被调用');
      if (this.$refs.fileUpload) {
        const files = this.$refs.fileUpload.files;
        console.log('文件列表:', files);
        if (!files || files.length === 0) {
          this.$message.warning('请先选择文件');
          return;
        }
        if (files.length > 1) {
          this.$message.warning('只能上传单一的合集 .mp4 视频文件');
          return;
        }
        const fileObj = files[0];
        const allFiles = files;
        console.log('文件对象:', fileObj, '共', allFiles.length, '个文件');
        console.log('当前上传行ID:', this.currentUploadRowId);

        if (!this.currentUploadRowId) {
          this.$message.error('未找到当前上传的行ID');
          return;
        }

        // 初始化操作栏进度条，状态为 calculating（黄色）
        console.log('设置进度条状态为 calculating');
        const newUploadingRows = { ...this.uploadingRows };
        newUploadingRows[this.currentUploadRowId] = {
          progress: 0,
          status: 'calculating',
          fileName: allFiles.length > 1 ? `${allFiles.length}个文件` : (fileObj.name || '未知文件'),
          fileCount: allFiles.length
        };
        this.uploadingRows = newUploadingRows;
        console.log('uploadingRows 状态:', this.uploadingRows);

        // 创建独立的上传实例
        const entrustNum = this.currentUploadRowId;
        const newInstances = { ...this.uploadInstances };
        newInstances[entrustNum] = {
          extraParams: { ...this.uploadExtraParams },
          fileObj: fileObj,
          allFiles: allFiles,
          status: 'calculating'
        };
        this.uploadInstances = newInstances;

        // 关闭对话框
        this.uploadDialogVisible = false;

        // 在下一个 tick 中，使用新的实例开始计算 MD5
        this.$nextTick(() => {
          console.log('使用独立实例开始计算 MD5, entrustNum:', entrustNum);
          const instanceRef = this.$refs['fileUpload_' + entrustNum];
          if (instanceRef && instanceRef[0]) {
            instanceRef[0].addFilesManually(allFiles);
            instanceRef[0].startCalculateMd5();
          } else {
            console.error('未找到上传实例:', entrustNum, 'refs:', this.$refs);
          }
        });
      }
    },
    // MD5 计算进度更新
    handleMd5Progress (data) {
      console.log('MD5 计算进度:', data);
      const entrustNum = data.extraParams?.entrustNum;
      if (entrustNum && this.uploadingRows[entrustNum]) {
        const newUploadingRows = { ...this.uploadingRows };
        newUploadingRows[entrustNum] = {
          ...newUploadingRows[entrustNum],
          progress: data.progress,
          status: 'calculating'
        };
        this.uploadingRows = newUploadingRows;
      }
    },

    // FileUpload 组件事件处理
    handleFileSelected (data) {
      console.log('文件已选择:', data);
    },
    handleMd5Calculated (data) {
      console.log('MD5 计算完成:', data);
      const entrustNum = data.extraParams?.entrustNum;
      // MD5 计算完成后，自动开始上传
      if (entrustNum && this.uploadingRows[entrustNum]) {
        // 更新进度条状态为 uploading
        const newUploadingRows = { ...this.uploadingRows };
        newUploadingRows[entrustNum] = {
          ...newUploadingRows[entrustNum],
          progress: 0,
          status: 'uploading'
        };
        this.uploadingRows = newUploadingRows;
        // 开始上传
        console.log('开始上传文件');
        this.$refs.fileUpload.startUpload();
      }
    },
    handleUploadStart (data) {
      console.log('开始上传:', data);
    },
    handleChunkUploaded (data) {
      console.log('分片上传完成:', data);
      const entrustNum = data.extraParams?.entrustNum;
      // 更新上传进度
      if (entrustNum && this.uploadingRows[entrustNum]) {
        console.log('更新进度:', data.uploadedCount / data.totalChunks);
        const newUploadingRows = { ...this.uploadingRows };
        newUploadingRows[entrustNum] = {
          ...newUploadingRows[entrustNum],
          progress: data.uploadedCount / data.totalChunks
        };
        this.uploadingRows = newUploadingRows;
        console.log('更新后的 uploadingRows:', this.uploadingRows);
      }
    },
    handleUploadSuccess (data) {
      console.log('上传成功:', data);
      const entrustNum = data.extraParams?.entrustNum;
      this.$message.success(`视频文件：${data.fileName || ''} 上传成功`);
      // 更新上传状态为成功
      if (entrustNum && this.uploadingRows[entrustNum]) {
        const newUploadingRows = { ...this.uploadingRows };
        newUploadingRows[entrustNum] = {
          ...newUploadingRows[entrustNum],
          progress: 1,
          status: 'success'
        };
        this.uploadingRows = newUploadingRows;
      }
      // 更新表格数据，不刷新列表
      if (entrustNum) {
        const rowIndex = this.tableData.findIndex(row => row.entrustNum === entrustNum);
        if (rowIndex > -1) {
          const updatedRow = { ...this.tableData[rowIndex] };
          updatedRow.videoSize = updatedRow.videoSize || 0;
          updatedRow.status = '上传成功';
          this.$set(this.tableData, rowIndex, updatedRow);
        }
      }
      // 2 秒后移除进度条
      setTimeout(() => {
        if (entrustNum) {
          const newUploadingRows = { ...this.uploadingRows };
          delete newUploadingRows[entrustNum];
          this.uploadingRows = newUploadingRows;
        }
      }, 2000);
    },
    handleUploadError (data) {
      console.error('上传失败:', data);
      const entrustNum = data.extraParams?.entrustNum;
      this.$message.error('视频文件上传失败');
      // 移除进度条，恢复初始状态
      if (entrustNum) {
        const newUploadingRows = { ...this.uploadingRows };
        delete newUploadingRows[entrustNum];
        this.uploadingRows = newUploadingRows;
      }
    },
    handleUploadCancel (data) {
      console.log('上传已取消:', data);
      const entrustNum = data.extraParams?.entrustNum;
      // 移除进度条
      if (entrustNum) {
        const newUploadingRows = { ...this.uploadingRows };
        delete newUploadingRows[entrustNum];
        this.uploadingRows = newUploadingRows;
      }
    },
    // 独立上传实例的事件处理方法
    handleInstanceMd5Progress (entrustNum, data) {
      console.log('实例 MD5 计算进度:', entrustNum, data);
      if (this.uploadingRows[entrustNum]) {
        const newUploadingRows = { ...this.uploadingRows };
        newUploadingRows[entrustNum] = {
          ...newUploadingRows[entrustNum],
          progress: data.progress,
          status: 'calculating'
        };
        this.uploadingRows = newUploadingRows;
      }
    },
    handleInstanceMd5Calculated (entrustNum, data) {
      console.log('实例单个文件 MD5 计算完成:', entrustNum, data);
    },
    handleInstanceAllMd5Calculated (entrustNum, data) {
      console.log('实例所有文件 MD5 计算完成，开始上传:', entrustNum, data);
      // 更新进度条状态为 uploading
      if (this.uploadingRows[entrustNum]) {
        const newUploadingRows = { ...this.uploadingRows };
        newUploadingRows[entrustNum] = {
          ...newUploadingRows[entrustNum],
          progress: 0,
          status: 'uploading'
        };
        this.uploadingRows = newUploadingRows;
      }
      // 开始上传（此时所有文件的MD5都已计算完毕）
      const instanceRef = this.$refs['fileUpload_' + entrustNum];
      if (instanceRef && instanceRef[0]) {
        instanceRef[0].startUpload();
      }
    },
    handleInstanceUploadStart (entrustNum, data) {
      console.log('实例开始上传:', entrustNum, data);
    },
    handleInstanceUploadProgress (entrustNum, data) {
      if (this.uploadingRows[entrustNum]) {
        const newUploadingRows = { ...this.uploadingRows };
        newUploadingRows[entrustNum] = {
          ...newUploadingRows[entrustNum],
          progress: data.progress,
          speedText: data.speedText
        };
        this.uploadingRows = newUploadingRows;
      }
    },
    handleInstanceChunkUploaded (entrustNum, data) {
      console.log('实例分片上传完成:', entrustNum, data);
      if (this.uploadingRows[entrustNum]) {
        const newUploadingRows = { ...this.uploadingRows };
        newUploadingRows[entrustNum] = {
          ...newUploadingRows[entrustNum],
          progress: data.progress !== undefined ? data.progress : (data.uploadedCount / data.totalChunks)
        };
        this.uploadingRows = newUploadingRows;
      }
    },
    handleInstanceUploadSuccess (entrustNum, data) {
      console.log('实例上传成功:', entrustNum, data);

      const responseValue = (data.response && data.response.data) ? data.response.data : data.response;
      const isNasSync = responseValue === '4' || responseValue === 4;

      if (isNasSync) {
        this.$message.warning('视频已成功上传，正在处理中，请稍后刷新列表查看。');
      } else {
        this.$message.success(`视频文件：${data.fileName || ''} 上传成功`);
      }

      // 更新上传状态为成功
      if (this.uploadingRows[entrustNum]) {
        const newUploadingRows = { ...this.uploadingRows };
        newUploadingRows[entrustNum] = {
          ...newUploadingRows[entrustNum],
          progress: 1,
          status: 'success'
        };
        this.uploadingRows = newUploadingRows;
      }
      // 更新表格数据，不刷新列表
      const rowIndex = this.tableData.findIndex(row => row.entrustNum === entrustNum);
      if (rowIndex > -1) {
        const updatedRow = { ...this.tableData[rowIndex] };
        // 设置状态：如果是 4 则设为 4，否则设为已上传
        updatedRow.status = isNasSync ? '4' : '已上传';
        // 设置 videoSize，让操作栏显示"重新上传"和"查看视频"按钮
        if (data.fileSize) {
          updatedRow.videoSize = data.fileSize;
        } else {
          updatedRow.videoSize = 1; // 设置一个非空值
        }
        // 设置视频文件URL（从合并接口响应中获取）
        if (data.response) {
          if (data.response.data && data.response.data.url) {
            updatedRow.videoFileUrl = data.response.data.url;
          } else if (data.response.url) {
            updatedRow.videoFileUrl = data.response.url;
          } else if (typeof data.response === 'string') {
            updatedRow.videoFileUrl = data.response;
          }
        }
        this.$set(this.tableData, rowIndex, updatedRow);
      }
      // 2 秒后移除进度条和实例
      setTimeout(() => {
        const newUploadingRows = { ...this.uploadingRows };
        delete newUploadingRows[entrustNum];
        this.uploadingRows = newUploadingRows;
        // 移除上传实例
        const newInstances = { ...this.uploadInstances };
        delete newInstances[entrustNum];
        this.uploadInstances = newInstances;
      }, 2000);
    },
    handleInstanceUploadError (entrustNum, data) {
      console.error('实例上传失败:', entrustNum, data);
      this.$message.error('视频文件上传失败');
      // 移除进度条和实例
      if (entrustNum) {
        const newUploadingRows = { ...this.uploadingRows };
        delete newUploadingRows[entrustNum];
        this.uploadingRows = newUploadingRows;
        // 移除上传实例
        const newInstances = { ...this.uploadInstances };
        delete newInstances[entrustNum];
        this.uploadInstances = newInstances;
      }
    },
    handleInstanceUploadCancel (entrustNum, data) {
      console.log('实例上传已取消:', entrustNum, data);
      // 移除进度条和实例
      if (entrustNum) {
        const newUploadingRows = { ...this.uploadingRows };
        delete newUploadingRows[entrustNum];
        this.uploadingRows = newUploadingRows;
        // 移除上传实例
        const newInstances = { ...this.uploadInstances };
        delete newInstances[entrustNum];
        this.uploadInstances = newInstances;
      }
    },
    // 根据行数据返回需要隐藏的按钮列表
    getDisabledButtons (row) {
      if (row.status == '3') {
        return ['handleUploadSingle', 'handleReUploadSingle', 'handleViewSingle'];
      }
      const disabled = [];
      // 如果 videoSize 有值，隐藏"上传"按钮
      if (row.videoSize) {
        disabled.push('handleUploadSingle');
      } else {
        // 如果 videoSize 为空，隐藏"重新上传"和"查看视频"按钮
        disabled.push('handleReUploadSingle');
        disabled.push('handleViewSingle');
      }

      return disabled;
    },
    // 查看视频
    handleViewSingle (row) {
      if (!row.videoFileUrl) {
        this.$message.warning('该记录暂无视频文件');
        return;
      }
      this.currentVideoUrl = row.videoFileUrl;
      this.videoDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.play().catch(error => {
            console.error('自动播放失败:', error);
          });
        }
      });
    },
    // 关闭视频播放对话框
    closeVideoDialog () {
      this.videoDialogVisible = false;
      // 停止视频播放
      this.$nextTick(() => {
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.pause();
          this.$refs.videoPlayer.currentTime = 0;
        }
        this.currentVideoUrl = '';
      });
    },
    // 分页大小改变
    handleSizeChange (val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 当前页改变
    handleCurrentChange (val) {
      this.queryParams.currPage = val;
      this.getList();
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}

.upload-demo {
  text-align: center;
}

.el-upload__tip {
  color: #999;
  font-size: 12px;
  margin-top: 10px;
}

.video-container {
  text-align: center;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-video {
  text-align: center;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
.upload-progress-cell {
  padding: 10px 0;
  width: 100%;
  display: flex;
  justify-content: flex-start;
}
.progress-wrapper {
  width: 65%;
  position: relative;
  display: flex;
  align-items: center;
}
.progress-wrapper .el-progress {
  flex: 1;
}
.progress-text {
  position: absolute;
  top: 50%;
  left: 32.5%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  font-weight: 500;
  color: #4a3000;
  white-space: nowrap;
  z-index: 10;
}
.progress-percentage {
  font-size: 12px;
  font-weight: 500;
  color: #4a3000;
  margin-left: 10px;
  white-space: nowrap;
}
.progress-text.text-calculating,
.progress-percentage.text-calculating {
  color: #6b4400;
}
.progress-text.text-uploading,
.progress-percentage.text-uploading {
  color: #1a5c00;
}
.progress-text.text-success,
.progress-percentage.text-success {
  color: #0f6600;
}
.progress-text.text-error,
.progress-percentage.text-error {
  color: #900000;
}
.upload-progress-cell .progress-label {
  font-size: 12px;
  font-weight: 500;
}
.upload-progress-cell .file-name {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
